import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import EpixBoxesTableRow from './EpixBoxesTableRow';
import SortIcons from '../../ProposalsSortIcons';

const EpikBoxesTable = ({ boxesList, selectedCompany, deleteMode, sortValue, onSort }) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => onSort('Company[0][name]')}>
              Company
              <SortIcons sortObj={sortValue} sortName="Company[0][name]" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('total')}>
              Total Edge Devices <SortIcons sortObj={sortValue} sortName="total" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('online')}>
              Registered <SortIcons sortObj={sortValue} sortName="online" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('offline')}>
              Un Registered <SortIcons sortObj={sortValue} sortName="offline" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('unmonitored')}>
              Unmonitored <SortIcons sortObj={sortValue} sortName="unmonitored" />
            </th>
            {/*<th>Alarmed</th>*/}
          </tr>
        </thead>
        <tbody>
          {boxesList && boxesList.length ? (
            boxesList.map((box, i) => (
              <EpixBoxesTableRow
                deleteMode={deleteMode}
                box={box}
                key={i}
                selectedCompany={val => selectedCompany(val)}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5}>
                <Alert rowSpan={5} color="info">
                  No Edge Device Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  null,
  null,
)(EpikBoxesTable);
